import { render } from "./Panel.vue?vue&type=template&id=1e8bff1a&scoped=true"
const script = {}

import "./Panel.vue?vue&type=style&index=0&id=1e8bff1a&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-1e8bff1a"

export default script